import { connect } from 'react-redux'
import TokenManager from './component'
import { commands, selectors } from '../../../../imports'
import { getActiveServerId, getServerIds } from '../../../../data'

function mapStateToProps(state) {
    return {
        activeServer: getActiveServerId(state),
        serverIds: getServerIds(state),
        tokens: selectors.getTokens(state),
        setToken: commands.launcherSetToken,
    }
}

export default connect(mapStateToProps)(TokenManager)



// WEBPACK FOOTER //
// ./src/features/Backend/components/Backend/components/TokenManager/index.js